<template>
    <main-content with_go_back_bar>
        <request-filter :action="filterAction"></request-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>
import columnsPf from './datatable/columns-pf'
import columnsStarshop from './datatable/columns-starshop'
import {ApiUrl, StarShopApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './actions-column'
import MainContent from "../../../../components/main-content";
import toastr from "toastr";
import RequestFilter from "./filter";

export default {

    components: {
        RequestFilter,
        MainContent,
    },
    data() {
        return {
            query: {},
            currentTab: 1,
            new_account: {},
            src: null,
            bank_name: null,
        }
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        datatableProps() {
            return {
                id: "deposit_requests_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url:this.gatewaySource === 'pf' ? ApiUrl.path('open-banking/deposit/admin/get-requests'):
                                StarShopApiUrl.path('open-banking/deposit/admin/get-requests'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: this.gatewaySource === 'pf'? columnsPf : columnsStarshop,
                actions: actionsColumn
            }
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
    }
}
</script>

<style>

</style>